module.exports = __webpack_public_path__ + "static/media/AddIcon.61be96a0.svg";